module.exports = __webpack_public_path__ + "static/media/bike2.ef6ec8b2.jpg";